import type { SortDirection, SortType } from "../components/BookExtracts/types";

// Type-aware comparison: numbers numerically, dates chronologically,
// strings case-insensitively via localeCompare.
const compareValues = (a: unknown, b: unknown, type: SortType): number => {
  if (type === "number") {
    return Number(a) - Number(b);
  }
  if (type === "date") {
    return new Date(a as string).getTime() - new Date(b as string).getTime();
  }
  return String(a).localeCompare(String(b), undefined, { sensitivity: "base" });
};

// Generic, non-mutating sort — returns a new sorted array so React state
// is never mutated in place.
export const sortItems = <T>(
  items: T[],
  key: keyof T,
  direction: SortDirection,
  type: SortType
): T[] => {
  return [...items].sort((a, b) => {
    const result = compareValues(a[key], b[key], type);
    return direction === "asc" ? result : -result;
  });
};
